import "https://player.vimeo.com/api/player.js";

const prefersReducedMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)"
).matches;

function setPausedUi(toggleBtn) {
  toggleBtn.setAttribute("data-state", "paused");
  toggleBtn.setAttribute("aria-label", toggleBtn.dataset.labelPlay);
}

function setPlayingUi(toggleBtn) {
  toggleBtn.setAttribute("data-state", "playing");
  toggleBtn.setAttribute("aria-label", toggleBtn.dataset.labelPause);
}

function setupMediaGridHosted() {
  document.querySelectorAll(".media-grid--item").forEach((item) => {
    const toggleBtn = item.querySelector(".media-grid--video-toggle");
    const video = item.querySelector(".media-grid--bg video");
    if (!toggleBtn || !video) return;

    if (prefersReducedMotion) {
      video.autoplay = false;
      video.pause();
      setPausedUi(toggleBtn);
    }

    toggleBtn.addEventListener("click", () => {
      if (video.paused) {
        video.play();
        setPlayingUi(toggleBtn);
      } else {
        video.pause();
        setPausedUi(toggleBtn);
      }
    });
  });
}

function setupMediaGridVimeo() {
  document.querySelectorAll(".media-grid-vimeo").forEach((videoEl) => {
    if (videoEl.hasAttribute("data-state")) {
      return;
    }
    videoEl.setAttribute("data-state", "initialized");
    const width = document.querySelector(".media-grid--item").offsetWidth;
    let player = new Vimeo.Player(videoEl, {
      id: videoEl.dataset.vimeoId,
      background: true,
      width: width + "px",
      controls: false,
    });

    const item = videoEl.closest(".media-grid--item");
    const toggleBtn = item?.querySelector(".media-grid--video-toggle");

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (
          entry.isIntersecting &&
          videoEl.dataset.state !== "playing" &&
          videoEl.dataset.state !== "paused-by-user" &&
          !prefersReducedMotion
        ) {
          player.play();
          videoEl.setAttribute("data-state", "playing");
        }
      });
    });
    observer.observe(videoEl);

    if (!toggleBtn) return;

    if (prefersReducedMotion) {
      setPausedUi(toggleBtn);
    }

    toggleBtn.addEventListener("click", async () => {
      if (toggleBtn.dataset.state === "playing") {
        await player.pause();
        videoEl.setAttribute("data-state", "paused-by-user");
        setPausedUi(toggleBtn);
      } else {
        await player.play();
        videoEl.setAttribute("data-state", "playing");
        setPlayingUi(toggleBtn);
      }
    });
  });
}

setupMediaGridHosted();
setupMediaGridVimeo();
